import ExampleFiberTree from "../../../../content/posts/react-fiber-reconciliation/example-fiber-tree.svg";
import ExampleFiberTree2 from "../../../../content/posts/react-fiber-reconciliation/example-fiber-tree-2.svg";
import FiberDebugExampleVideo from "../../../../content/posts/react-fiber-reconciliation/fiber_debbug_example.webm";
import * as React from 'react';
export default {
  ExampleFiberTree,
  ExampleFiberTree2,
  FiberDebugExampleVideo,
  React
};